// extracted by mini-css-extract-plugin
export default {"root":"pagination_root__9hhB6","circle":"pagination_circle__sbGZD","circleMain":"pagination_circleMain__I9LMb","active":"pagination_active__c4hm5"};